import { alpha, CircularProgress, makeStyles, Box, Theme } from "@material-ui/core"
import { useGetUserInfoQuery } from "../api"
import UserEmailSetting from "./email-setting"
import UserPasswordSetting from "./password-setting"
import UserLocaleSettings from "./UserLocaleSettings"
import AccountDeletionCard from "./account-deletion/AccountDeletionCard"
import HourReportFeature from "./HourReportFeature"

const UserGeneralSettings = () => {
  const classes = useStyles()
  const { data: user, isLoading } = useGetUserInfoQuery()

  if (isLoading || !user) return <CircularProgress />

  return (
    <div style={{ margin: "auto", maxWidth: 850 }}>
      <Box className={classes.box}>
        <UserEmailSetting user={user} />
      </Box>
      <Box className={classes.box}>
        <UserPasswordSetting user={user} />
      </Box>
      <Box className={classes.box} sx={{ display: "flex", flexWrap: "wrap" }}>
        <UserLocaleSettings user={user} />
      </Box>
      <Box className={classes.box}>
        <HourReportFeature user={user} />
      </Box>
      <section className={classes.deleteAccountSection}>
        <AccountDeletionCard user={user} />
      </section>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  deleteAccountSection: {
    padding: theme.spacing(4),
    margin: theme.spacing(2, 0),
    border: `1px solid ${alpha(theme.palette.error.main, 0.25)}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.error.main, 0.05),
  },
}))

export default UserGeneralSettings
